import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const UsageManagement = lazy(() =>
  import("@scenes/UsageManagement").then((module) => ({
    default: module.UsageManagement,
  }))
);

export const usageManagementNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("usage-management-nro-heading", "Usage Management"),
  pageNameForTracking: () => "Usage Management",
  Component: UsageManagement,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("enable_billing_governance_controls") && hasPermission("appGroup", { permission: "viewBilling" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
